import KeyboardSpace from './KeyboardSpace';

export default KeyboardSpace;
export { KeyboardSpace };
export type { KeyboardSpaceProps } from './KeyboardSpace';
